import React from 'react';
import {InferPropTypes} from 'commons/types/Types';
import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';
import InnerFormAddressProof from './InnerFormAddressProof';
import {AddressProofValues} from 'commons/models';
import {formValidator} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';
import {FieldShape} from 'commons/shapes';

AddressProofForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired)
        .isRequired,
    addressProof: PropTypes.any
};

const FormControl = withFormik<
    InferPropTypes<typeof AddressProofForm.propTypes>,
    AddressProofValues
>({
    mapPropsToErrors: () => {
        return {
            file: '',
        };
    },
    mapPropsToValues: (props) => {
        return {
            file: props.addressProof || '',
        };
    },
    validate: (values: AddressProofValues, props) => {
        const errors: FormikErrors<AddressProofValues> = {};
        formValidator(props.fields, errors, values);
        if (!values.file) {
            errors.file = Messages.FILE_NOT_SELECTED;
        }
        return errors;
    },
    validateOnBlur: true,
    validateOnChange: true,
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler(values);
    },
})(InnerFormAddressProof);

function AddressProofForm(
    props: InferPropTypes<typeof AddressProofForm.propTypes>
) {
    const {submitHandler, fields, addressProof} = props;

    return (
        <div className='AddressProofForm'>
            <FormControl
                // eslint-disable-next-line react/jsx-handler-names
                submitHandler={submitHandler}
                fields={fields}
                addressProof={addressProof}
            />
        </div>
    );
}
export default AddressProofForm;
